import axios from 'axios';
import promise from 'promise';
import { environmentName } from './environment/environment';
import { getCSRFToken } from './csrfToken';

var axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      if (environmentName === 'dev' && window.location.hostname === 'localhost') {
        config.headers = {
          'hc-api-token': '01gyWpGKnDAL3/0BNMJFFRUsQbbFwWQ8DvPCmLN0ToY=',
          'hc-applicant-id': 0
        };
      }
      
      // Add CSRF token to POST, PUT, PATCH, and DELETE requests
      if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
        // Skip CSRF token for the csrf-token endpoint itself to avoid circular dependency
        if (!config.url?.includes('/csrf-token')) {
          const csrfToken = await getCSRFToken();
          if (csrfToken) {
            config.headers = config.headers || {};
            config.headers['X-CSRF-Token'] = csrfToken;
          }
        }
      }
    } catch (err) {
      console.log('Error while axiosInstance......' + err);
    }
    return config;
  },
  (error) => {
    return promise.reject(error);
  }
);

export default axiosInstance;
